function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettlersPlayer = /*#__PURE__*/function () {
  function SettlersPlayer() {
    _classCallCheck(this, SettlersPlayer);
  }
  return _createClass(SettlersPlayer, [{
    key: "playerMoveBandit",
    value:
    //Select the person to steal from
    function playerMoveBandit(player, hexId) {
      var settlers_self = this;
      this.halted = 1;
      //Find adjacent cities and launch into stealing mechanism
      var thievingTargets = [];
      var _iterator = _createForOfIteratorHelper(this.game.state.cities),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var city = _step.value;
          if (city.neighbours.includes(hexId)) {
            if (city.player != player) if (!thievingTargets.includes(city.player)) thievingTargets.push(city.player);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (thievingTargets.length > 0) {
        var robPlayer = function robPlayer(victim) {
          var potentialLoot = settlers_self.game.state.players[victim - 1].resources;
          if (potentialLoot.length > 0) {
            var loot = potentialLoot[Math.floor(Math.random() * potentialLoot.length)];
            settlers_self.addMove("steal_card\t".concat(player, "\t").concat(victim, "\t").concat(loot));
          } else settlers_self.addMove("steal_card\t".concat(player, "\t").concat(victim, "\tnothing"));
          settlers_self.endTurn();
        };
        if (thievingTargets.length > 1) {
          var html = '<div class="status-header"><span id="status-content">steal from which Player:</span></div>';
          html += "<div class=\"status-text-menu\"> <ul>";
          for (var i = 0; i < this.game.players.length; i++) {
            if (thievingTargets.includes(i + 1)) {
              html += "<li class=\"textchoice steal-player-choice\" id=\"".concat(i + 1, "\">").concat(settlers_self.game.playerNames[i], " (").concat(settlers_self.game.state.players[i].resources.length, " cards)</li>");
            }
          }
          html += "</ul></div>";
          this.hud.updateStatus(html);

          //Select a player to steal from
          $(".textchoice").off();
          $(".textchoice").on("click", function () {
            $(".textchoice").off();
            var victim = $(this).attr("id");
            robPlayer(victim);
          });
        } else {
          robPlayer(thievingTargets[0]);
        }
      } else {
        //No one to steal from
        settlers_self.addMove("steal_card\t".concat(player, "\t0\tnothing"));
        settlers_self.endTurn();
      }
    }

    //
    // when 7 is rolled or Soldier Played
    // Select the target spot
    //
  }, {
    key: "playerPlayBandit",
    value: function playerPlayBandit() {
      var xpos = 0;
      var ypos = 0;
      this.updateStatus("MOVE the <span class=\"to-upper\">".concat(this.b.name, "</span>:"));
      $(".option").css("visibility", "hidden");
      var settlers_self = this;
      $(".sector-container").addClass("rhover");
      $(".sector-container").off();
      $('.sector-container').on('mousedown', function (e) {
        xpos = e.clientX;
        ypos = e.clientY;
      });
      $('.sector-container').on('mouseup', function (e) {
        if (Math.abs(xpos - e.clientX) > 4) {
          return;
        }
        if (Math.abs(ypos - e.clientY) > 4) {
          return;
        }
        $(".sector-container").off();
        $(".sector-container").removeClass("rhover");
        var slot = $(this).attr("id");
        settlers_self.addMove("move_bandit\t".concat(settlers_self.game.player, "\t").concat(slot));
        settlers_self.endTurn();
      });
      $(".bandit").removeClass("rhover");
      $(".bandit").off(); //Don't select bandit tile
    }
  }, {
    key: "canPlayerBuildTown",
    value: function canPlayerBuildTown(player) {
      if (!this.game.state.hasRolled || this.game.state.playerTurn !== this.game.player) return false;
      if (this.game.state.players[player - 1].towns == 0) return false;
      if (this.returnCitySlotsAdjacentToPlayerRoads(this.game.player).length == 0) return false;
      return this.doesPlayerHaveResources(player, this.priceList[1]);
    }
  }, {
    key: "playerBuildTown",
    value: function playerBuildTown(player) {
      var canBackUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var settlers_self = this;
      var existing_cities = 0;
      this.halted = 1;
      for (var i = 0; i < this.game.state.cities.length; i++) {
        if (this.game.state.cities[i].player == this.game.player) {
          existing_cities++;
        }
      }
      var xpos, ypos;
      $(".flash").removeClass("flash");
      /*
        Everyone starts with 2 settlements and can be placed anywhere on island
        */
      if (existing_cities < 2) {
        if (existing_cities == 1) {
          this.hud.updateStatus("<div class=\"player-notice\">YOUR TURN: place your second ".concat(this.c1.name, "</div>"));
        } else {
          this.hud.updateStatus("<div class=\"player-notice\">YOUR TURN: place your first ".concat(this.c1.name, "</div>"));
        }
        $(".city.empty").addClass("chover");
        //$('.city').css('z-index', 9999999);
        $(".city.empty").off();
        $(".city.empty[data-score=\"15\"]").addClass("noselect");
        $(".city.empty[data-score=\"14\"]").addClass("noselect");
        //$('.city.noselect').removeClass("empty");

        $(".city.empty").on("mousedown", function (e) {
          xpos = e.clientX;
          ypos = e.clientY;
        });
        //Create as menu on the game board to input word from a tile in horizontal or vertical direction
        $(".city.empty").on("mouseup", function (e) {
          if (Math.abs(xpos - e.clientX) > 4) {
            return;
          }
          if (Math.abs(ypos - e.clientY) > 4) {
            return;
          }
          if ($(this).hasClass("noselect")) {
            salert("This space is too valuable for an initial placement");
            return;
          }
          $(".city.empty").css("background-color", "");
          //Confirm this move
          var slot = $(this).attr("id");
          settlers_self.confirmPlacement(slot, settlers_self.c1.name, function () {
            $(".city.empty").removeClass("chover");
            $(".city.empty").off();
            settlers_self.game.state.placedCity = slot;
            //settlers_self.buildCity(settlers_self.game.player, slot);
            if (existing_cities == 1) settlers_self.addMove("secondcity\t".concat(settlers_self.game.player, "\t").concat(slot.replace("city_", "")));
            settlers_self.addMove("build_city\t".concat(settlers_self.game.player, "\t").concat(slot));
            settlers_self.endTurn();
          });
        });
      } else {
        /* During game, must build roads to open up board for new settlements*/
        this.updateStatus("you may build a ".concat(this.c1.name, "..."));
        if (canBackUp) {
          this.updateControls("<i class=\"fa-solid fa-xmark\"></i>");
          document.getElementById("rolldice").onclick = function (e) {
            //Make sure the confirm popup goes away
            $(".action").off();
            $(".popup-confirm-menu").remove();
            $(".rhover").off();
            $(".rhover").removeClass("rhover");
            settlers_self.addMove("undo_build\t".concat(settlers_self.game.player, "\t1"));
            settlers_self.endTurn();
          };
        }
        var building_options = this.returnCitySlotsAdjacentToPlayerRoads(this.game.player);
        for (var _i = 0; _i < building_options.length; _i++) {
          console.log(building_options[_i]);
          var divname = "#" + building_options[_i];
          $(divname).addClass("rhover");
        }
        $(".rhover").off();
        $(".rhover").on("mousedown", function (e) {
          xpos = e.clientX;
          ypos = e.clientY;
        });
        $(".rhover").on("mouseup", function (e) {
          if (Math.abs(xpos - e.clientX) > 4) {
            return;
          }
          if (Math.abs(ypos - e.clientY) > 4) {
            return;
          }
          var slot = $(this).attr("id");
          $(".rhover").css("background-color", "");
          settlers_self.confirmPlacement(slot, settlers_self.c1.name, function () {
            $(".rhover").off();
            $(".rhover").removeClass("rhover");

            //settlers_self.buildCity(settlers_self.game.player, slot);
            settlers_self.addMove("build_city\t".concat(settlers_self.game.player, "\t").concat(slot));
            settlers_self.endTurn();
          });
        });
      }
    }
  }, {
    key: "canPlayerBuildRoad",
    value: function canPlayerBuildRoad(player) {
      if (!this.game.state.hasRolled || this.game.state.playerTurn !== this.game.player) return false;
      return this.doesPlayerHaveResources(player, this.priceList[0]);
    }
  }, {
    key: "playerBuildRoad",
    value: function playerBuildRoad(player) {
      var canBackUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var settlers_self = this;
      this.halted = 1;
      if (this.game.state.placedCity) {
        this.hud.updateStatus("<div class=\"player-notice\">YOUR TURN: place a connecting ".concat(this.r.name, "</diiv>"));
        var newRoads = this.hexgrid.edgesFromVertex(this.game.state.placedCity.replace("city_", ""));
        var _iterator2 = _createForOfIteratorHelper(newRoads),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var road = _step2.value;
            $("#road_".concat(road)).addClass("new");
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        $(".road.new").addClass("rhover");
        $(".road.new").off();
        $(".road.new").on("click", function () {
          var slot = $(this).attr("id");
          $(".road.empty").css("background-color", "");
          settlers_self.confirmPlacement(slot, settlers_self.r.name, function () {
            $(".road.new").off();
            $(".road.new").removeAttr("style");
            $(".rhover").removeClass("rhover");
            $(".road.new").removeClass("new");
            settlers_self.addMove("build_road\t".concat(settlers_self.game.player, "\t").concat(slot));
            settlers_self.endTurn();
          });
        });
      } else {
        this.updateStatus("you may build a ".concat(this.r.name, "..."));
        if (canBackUp) {
          this.updateControls("<i class=\"fa-solid fa-xmark\"></i>");
          document.getElementById("rolldice").onclick = function (e) {
            //Make sure the confirm popup goes away
            $(".action").off();
            $(".popup-confirm-menu").remove();
            $(".road.empty").off();
            $(".rhover").removeClass("rhover");
            $(".road.empty").removeAttr("style");
            settlers_self.addMove("undo_build\t".concat(settlers_self.game.player, "\t0"));
            settlers_self.endTurn();
          };
        }

        /*Normal game play, can play road anywhere empty connected to my possessions*/
        $(".road.empty").addClass("rhover");
        $(".road.empty").off();
        $(".road.empty").on("click", function () {
          var slot = $(this).attr("id");
          $(".road.empty").removeAttr("style");
          settlers_self.confirmPlacement(slot, settlers_self.r.name, function () {
            $(".road.empty").off();
            $(".rhover").removeClass("rhover");
            $(".road.empty").removeAttr("style");
            settlers_self.addMove("build_road\t".concat(settlers_self.game.player, "\t").concat(slot));
            settlers_self.endTurn();
          });
        });
      }
    }
  }, {
    key: "canPlayerBuildCity",
    value: function canPlayerBuildCity(player) {
      if (!this.game.state.hasRolled || this.game.state.playerTurn !== this.game.player) return false;
      var availableSlot = false;
      var _iterator3 = _createForOfIteratorHelper(this.game.state.cities),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          if (i.player == player && i.level == 1) availableSlot = true;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (!availableSlot) return false;
      if (this.game.state.players[player - 1].cities == 0) return false;
      return this.doesPlayerHaveResources(player, this.priceList[2]);
    }
  }, {
    key: "playerBuildCity",
    value: function playerBuildCity(player) {
      var canBackUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.halted = 1;
      this.updateStatus("click on a ".concat(this.c1.name, " to upgrade it to a ").concat(this.c2.name, "..."));
      if (canBackUp) {
        this.updateControls("<i class=\"fa-solid fa-xmark\"></i>");
        document.getElementById("rolldice").onclick = function (e) {
          //Make sure the confirm popup goes away
          $(".action").off();
          $(".popup-confirm-menu").remove();
          //Disable board event selection
          $(".chover").off();
          $(".chover").removeClass("chover");
          settlers_self.addMove("undo_build\t".concat(settlers_self.game.player, "\t2"));
          settlers_self.endTurn();
        };
      }
      var settlers_self = this;
      //let selector = `.city.p${this.game.colors[player-1]}`;
      //Manually go through available player's cities because DOM doesn't have convenient selector
      var _iterator4 = _createForOfIteratorHelper(settlers_self.game.state.cities),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var c = _step4.value;
          if (c.level === 1 && c.player === player) {
            $("#" + c.slot).addClass("chover");
          }
        }

        //$(selector).addClass('chover');
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      $(".chover").off();
      $(".chover").on("click", function () {
        //>>>>>>>>>>>>>>>>>
        var slot = $(this).attr("id");
        $(".chover").removeAttr("style");
        $(this).css("border-color", "yellow");
        settlers_self.confirmPlacement(slot, settlers_self.c2.name, function () {
          $(".chover").removeAttr("style");
          $(".chover").off();
          $(".chover").removeClass("chover");
          for (var i = 0; i < settlers_self.game.state.cities.length; i++) {
            if (slot == settlers_self.game.state.cities[i].slot && settlers_self.game.state.cities[i].level == 1) {
              settlers_self.addMove("upgrade_city\t".concat(settlers_self.game.player, "\t").concat(slot));
              settlers_self.endTurn();
              return;
            }
          }
          //Something went wrong, try again
          console.warn("Unexpected error in upgrading a city");
          settlers_self.playerBuildCity(player);
        });
      });
    }

    /*
      Main function to let player carry out their turn...
      */
  }, {
    key: "playerPlayMove",
    value: function playerPlayMove() {
      var _this = this;
      var can_do_something = false;
      if (this.canPlayerTradeWithBank()) {
        can_do_something = true;
        $("#bank").addClass("enabled");
      } else {
        $("#bank").removeClass("enabled");
      }
      if (this.canPlayerPlayCard()) {
        can_do_something = true;
        $("#playcard").addClass("enabled");
      } else {
        $("#playcard").removeClass("enabled");
      }
      if (this.canPlayerBuildRoad(this.game.player) || this.canPlayerBuildTown(this.game.player) || this.canPlayerBuildCity(this.game.player) || this.canPlayerBuyCard(this.game.player)) {
        can_do_something = true;
        $("#spend").addClass("enabled");
      } else {
        $("#spend").removeClass("enabled");
      }
      $(".controls .option").css("visibility", "visible");
      $("#rolldice").html("<i class=\"fa-solid fa-forward\"></i>");
      $("#rolldice").addClass("enabled");

      //
      // auto-end my turn if I cannot do anything
      //
      if (can_do_something != true) {
        this.addMove("end_turn\t" + this.game.player); //End turn deletes the previous move (player_actions)
        this.addMove("ACKNOWLEDGE\tyou cannot do anything - end turn\t" + this.game.player);
        this.endTurn();
        return;
      }

      //
      // Set timer to auto-end my turn if I take too long
      // 
      if (this.turn_limit) {
        this.setShotClock("#rolldice", this.turn_limit, false);
      }
      var statushtml = "YOUR TURN:";
      this.updateStatus("".concat(statushtml));
      document.getElementById("rolldice").onclick = function (e) {
        e.currentTarget.onclick = null;
        _this.addMove("end_turn\t" + _this.game.player);
        _this.endTurn();
      };
    }
  }, {
    key: "canPlayerTradeWithBank",
    value: function canPlayerTradeWithBank() {
      var minForTrade = this.analyzePorts(); //4;  //1) Fix to have 3:1 port, 2) Fix for resource specific 2:1 ports

      if (!this.game.state.canTrade) {
        return false;
      }
      if (!this.game.state.hasRolled || this.game.state.playerTurn !== this.game.player) return false;
      var _iterator5 = _createForOfIteratorHelper(this.returnResources()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var resource = _step5.value;
          if (this.countResource(this.game.player, resource) >= minForTrade[resource]) return true;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return false;
    }
  }, {
    key: "canPlayerBuyCard",
    value: function canPlayerBuyCard(player) {
      //No more cards in deck (No reshuffling in this game)
      if (!this.game.state.hasRolled || this.game.state.playerTurn !== this.game.player) return false;
      if (this.game.deck[0].crypt.length === 0) return false;
      return this.doesPlayerHaveResources(player, this.priceList[3]);
    }
  }, {
    key: "canPlayerPlayCard",
    value: function canPlayerPlayCard() {
      var onlyKnights = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.game.state.bandit) {
        return false;
      }
      if (this.game.state.playerTurn !== this.game.player) {
        console.log("not my turn");
        return false;
      }
      console.log(this.game.state.players[this.game.player - 1].devcards);
      if (onlyKnights) {
        var _iterator6 = _createForOfIteratorHelper(this.game.state.players[this.game.player - 1].devcards),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var c = _step6.value;
            var card = this.game.deck[0].cards[c];
            console.log(card);
            if (card.action == 1) {
              return true;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } else {
        if (this.game.state.players[this.game.player - 1].devcards.length > 0) {
          return this.game.state.canPlayCard;
        }
      }
      return false;
    }
  }]);
}();
module.exports = SettlersPlayer;